<template>
  <b-row>

    <!-- User Info: Left col -->
    <b-col
      cols="20"
      xl="12"
      class="d-flex justify-content-between flex-column"
    >
      <b-card
        no-body
        class="card-employee-task"
      >
        <b-card-header
          class="header-background"
        >
          <b-card-title>{{ $t('DEBTIA_GENERAL_INFORMATION') }}</b-card-title>
        </b-card-header>

        <!-- body -->
        <b-card-body>
          <b-row>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column row-right-border"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_NAME') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.name ? userData.data.name : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_USERNAME') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.username ? userData.data.username : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_EMAIL') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75"><a :href="'mailto:' + userData.data.email">{{ userData.data.email ? userData.data.email : 'N/A' }}</a></small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_PHONE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.phone ? userData.data.phone : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_LOGIN') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.loginStatus === '0' ? "Not Allowed" : "Allowed" }}</small>
                </div>
              </div>
            </b-col>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_CONTACT_PERSON') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.contact_person ? userData.data.contact_person : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_DEBTOR_TYPE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.debtor_type }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_BIRTHDATE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.birthdate ? userData.data.birthdate : 'N/A' }}</small>
                </div>
              </div>
              <div
                v-if="userData.data.vat_exempted"
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_VAT_EXEMPTION') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.vat_exempted === 0 ? $t('DEBTIA_NO') : $t('DEBTIA_YES') }}</small>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <!-- User Info: Left col -->
            <b-col
              :cols="userData.data.address_logs.length > 0 ? '6' : '12'"
              :xl="userData.data.address_logs.length > 0 ? '6' : '12'"
              class="d-flex justify-content-between flex-column address-margin"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h4 class="mb-0">
                      {{ $t('DEBTIA_ADDRESS') }}
                    </h4>
                  </b-media-body>
                </b-media>
              </div>
            </b-col>
            <b-col
              v-if="userData.data.address_logs && userData.data.address_logs.length > 0"
              cols="6"
              lg="6"
              class="address-history-icon"
            >
              <feather-icon
                id="popover-address-history"
                ref="button"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                icon="SidebarIcon"
                size="16"
                class="side-feather-icon"
              />
            </b-col>

            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column row-right-border"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_HOUSE_NUMBER') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.debtor_address && userData.data.debtor_address.house_no ? userData.data.debtor_address.house_no : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_ROAD_NAME') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.debtor_address && userData.data.debtor_address.road_name ? userData.data.debtor_address.road_name : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_PLACE_NAME') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.debtor_address && userData.data.debtor_address.place ? userData.data.debtor_address.place : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_COURT') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.debtor_address && userData.data.debtor_address.court_id && userData.data.debtor_address.court_id > 0 ? getCourtTitle(userData.data.debtor_address.court_id) : 'N/A' }}</small>
                </div>
              </div>
            </b-col>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_ZIP_CODE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.debtor_address && userData.data.debtor_address.zip_code ? userData.data.debtor_address.zip_code : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_CITY') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.debtor_address && userData.data.debtor_address.city ? userData.data.debtor_address.city : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_COUNTRY') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.debtor_address && userData.data.debtor_address.country ? userData.data.debtor_address.country : 'N/A' }}</small>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="12"
              class="d-flex justify-content-between flex-column address-margin"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h4 class="mb-0">
                      {{ $t('DEBTIA_GENERAL_INFORMATION') }}
                    </h4>
                  </b-media-body>
                </b-media>
              </div>
            </b-col>
            <b-col
              v-for="variable in userData.data.custom_variables_v2"
              :key="variable.custom_variable_id"
              cols="6"
              xl="6"
              class="d-flex justify-content-between flex-column row-right-border pb-1"
            >
              <div
                v-if="variable.display_in_detail_page === 1 || variable.display_in_detail_page === true"
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t(variable.customVarLabel) }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{
                    variable.customVarValue ? variable.type === 'select' ?
                      selectedLabel(variable) : variable.customVarValue
                    : 'N/A'
                  }}</small>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col
      cols="12"
      xl="12"
      class="d-flex justify-content-between flex-column"
    >
      <b-card
        no-body
        class="card-employee-task"
      >
        <b-card-header
          class="header-background"
        >
          <b-card-title>{{ $t('DEBTIA_BANK_INFORMATION') }}</b-card-title>
        </b-card-header>

        <!-- body -->
        <b-card-body>
          <b-row>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column row-right-border"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_BANK_BRANCH_NO') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.bank_branch_no ? userData.data.bank_branch_no : 'N/A' }}</small>
                </div>
              </div>
            </b-col>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_BANK_ACCOUNT_NO') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.bank_account_no ? userData.data.bank_account_no : 'N/A' }}</small>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <address-history
        :addresses-history="userData.data.address_logs"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BRow, BCol, BCardHeader, BCardTitle, BCardBody, BMedia, BMediaBody,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import axios from '@axios'
// import useUsersList from '../clients-list/useClientsList'
import Ripple from 'vue-ripple-directive'
import AddressHistory from './AddressHistory.vue'

export default {
  components: {
    BCard, BRow, BCol, BCardHeader, BCardTitle, BCardBody, BMedia, BMediaBody, AddressHistory,
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      courts: [],
    }
  },
  created() {
    this.getCourtsDropdown()
  },
  setup() {
    // const { resolveUserRoleVariant } = useUsersList()
    return {
      avatarText,
      // resolveUserRoleVariant,
    }
  },
  methods: {
    getCourtTitle(id) {
      const entry = this.courts.filter(record => record.value === id)
      let title = 'N/A'
      if (entry[0]) {
        title = entry[0].label
      }
      return title
    },
    async getCourtsDropdown() {
      await axios.get('settings/courts/dropdown')
        .then(response => {
          this.courts = response.data.data
        }).catch(() => false)
    },
    selectedLabel(variable) {
      const options = variable.options.length > 0 ? [...variable.options] : [...this.userData.data.airports]
      const x = options.filter(e => e.value === variable.customVarValue)
      return x.length > 0 ? x[0].label : 'N/A'
    },
  },
}
</script>

<style>
.row-right-border {
  border-right: 1px solid #d9d9d9;
}

.header-background {
  background-color: #7c9b98  !important;
  margin-bottom: 20px;
}

.header-background h4.card-title{
  color: #ffffff;
}

.address-margin {
  margin: 25px 0px 25px 0px;
}

.address-history-icon {
  padding-top: 25px;
  border-right: 2px solid #219289;
  margin-top: 10px;
}

.address-history-icon .side-feather-icon {
  float: right;
  stroke-width: 2.5;
}
</style>
